//Importaciones
import React from 'react'
import { useContext } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MessageBox from '../../../../components/Common/Message/MessageBox';
import MainAppContext from '../../../../MainAppContext';
import { useSelector } from 'react-redux';
import { useGetUserPropsKpi } from '../../../../hooks/services/sPrivilege/useOfPrivilege';
import AuthVerify from '../../../../components/Templates/Site/AuthVerify';
import CalendarFilterMonthOnly from '../../../../components/Products/sKPI/Board/CalendarFilterMonthOnly';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { useGetBoardStructureComponentsData2, useGetBoardStructureGeneric } from '../useOfBoard';
import { Card, Col, Row } from 'react-bootstrap';
import BoardComponentInfoContent from '../ComponentManager/BoardComponentInfoContent';
import { enum__BOARD_TEMPLATE_TYPE, enum__ComponentType, enum__ComponentType_InvertedEnum } from '../../../../common/Dictionaries';
import { __onGetDataGridHtmlContainer } from '../../../../common/CommonFuctions';
import Loading from '../../../../components/Templates/Site/Loading';
import CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE from '../../../../components/Products/sKPI/Board/_ComponentTypes/CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../common/Helpers';
import { useGetContracSimpletByElementId } from '../../../../hooks/services/sKPI/useOfBoard';
import { ActionButton } from '@fluentui/react';
import { ExportPowerBiToPdf } from '../../../../common/FileManager/ExportFunction';
import ReactApexChart from "react-apexcharts";
import ApexCharts from "apexcharts";
import POWERBI_COMPONENT_OCR from '../../../../components/Products/sKPI/Board/_ComponentTypes/POWERBI_COMPONENT_OCR';



function PowerBI(props) {
    //Helpers
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);
    const contextSite = useContext(MainAppContext);

    const queryStringElementId = props.match.params.elementId !== null && props.match.params.elementId !== undefined && props.match.params.elementId !== "" ? props.match.params.elementId : null;

    const { _boardComponentInfoRecursiveFilled: boardComponentInfoRecursiveFilled } = useSelector((state) => state.boardViewComponentsScope);
    const { _boardContractFilterOfComponents: boardContractFilterOfComponents } = useSelector((state) => state.boardViewComponentsScope);
    const { _boardComponentInfoRecursiveValues: boardComponentInfoRecursiveValues } = useSelector((state) => state.boardViewComponentsScope);

    const ResponsiveGridLayout = WidthProvider(Responsive);
    const BoardTypeId = enum__BOARD_TEMPLATE_TYPE.POWERBI;
    const hasPageElementId = true;
    
    const [boardStructureGeneric, setBoardStructureGeneric] = useState(null)

    const [messageConfig, setMessageConfig] = useState({ message : null, messageType : "error", showMessage : true });
    const [userPropsKpi, setUserPropsKpi] = useState({hasAccess : null, onlyObserver: null})
    const [contract, setContract] = useState(null)
    useGetUserPropsKpi(BoardTypeId, !isNullUndefinedOrEmpty(boardStructureGeneric) ? (!isNullUndefinedOrEmpty(boardStructureGeneric.boardId) ? boardStructureGeneric.boardId : (boardStructureGeneric.length > 0 ? boardStructureGeneric[0].id : 0)) : 0, queryStringElementId, currentAuth.token.userName, userPropsKpi, setUserPropsKpi)
    useGetContracSimpletByElementId(queryStringElementId, contract, setContract,
        contextSite.kpiModule.boardCalendarFilterConfig.value,
        contextSite.kpiModule.boardCalendarFilterConfig.setter)

    const layoutConfiguration = {
        measureBeforeMount: true,
        breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
        cols: { lg: 36, md: 30, sm: 18, xs: 12, xxs: 6 },
        rowHeight: 46,
        draggableHandle: ".dragHandle",
        margin: [10, 10, 10, 10]
    }

    useGetBoardStructureGeneric(BoardTypeId, queryStringElementId, boardStructureGeneric, setBoardStructureGeneric);
    useGetBoardStructureComponentsData2(boardContractFilterOfComponents, hasPageElementId, queryStringElementId, boardStructureGeneric, contextSite.kpiModule.boardCalendarFilterConfig, boardComponentInfoRecursiveFilled, false);

    const generateContainer = (boardStructure, container) => {
        return  <>
                    {
                        container.l_components_info.map((componentInfo, index) => {
                            return  <div key={index} className='h-100'
                            data-container-id={!isNullUndefined(componentInfo) ? componentInfo.containerId : ''}
                            data-component-id={!isNullUndefined(componentInfo) ? componentInfo.id : ''}>
                                        <BoardComponentInfoContent
                                            inputParam_HasPageElementId={hasPageElementId}
                                            inputParam_ElementId={queryStringElementId}
                                            inputParam_ContainerComponent={componentInfo}
                                            inputParam_BoardType={BoardTypeId}
                                            inputParam_BoardId={boardStructureGeneric[0].id}
                                            inputParam_BoardStructure={boardStructure}
                                            inputParam_Index={index}
                                        />
                                    </div>  
                        })
                    }
                </>
    };

    const ExportToPdf = async () => {
        const componentData_table = boardComponentInfoRecursiveValues[enum__ComponentType_InvertedEnum[enum__ComponentType.POWERBI_COMPONENT_TABLE]]
        const componentData_gridkpis = boardComponentInfoRecursiveValues[enum__ComponentType_InvertedEnum[enum__ComponentType.POWERBI_COMPONENT_KEY_KPIS]]
        const componentData_charts = boardComponentInfoRecursiveValues[enum__ComponentType_InvertedEnum[enum__ComponentType.POWERBI_COMPONENT_OCR]]
        const componentData_contract = boardComponentInfoRecursiveValues[enum__ComponentType_InvertedEnum[enum__ComponentType.SG3_HEADER]]
        const componentData_roles = boardComponentInfoRecursiveValues[enum__ComponentType_InvertedEnum[enum__ComponentType.ELEMENT_ROLES]]

        const data_table = componentData_table.length > 0 && componentData_table[0].componentData.item.length > 0 ? componentData_table[0].componentData.item[0] : null;
        const data_kpis = componentData_gridkpis.length > 0 && componentData_gridkpis[0].componentData.items.length > 0 ? componentData_gridkpis[0].componentData.items : null;
        const data_charts = componentData_charts.length > 0 ? componentData_charts : null;
        const data_roles = componentData_roles.length > 0 && componentData_roles[0].componentData.items.length > 0 ? componentData_roles[0].componentData.items : [];
        const data_contract = componentData_contract.length > 0 && componentData_contract[0].componentData.items.length > 0 ? componentData_contract[0].componentData.items : [];

        let chart_refs_dataUris = await Promise.all(
            data_charts.map(dc => ApexCharts.exec(`powerbi-chart-to-export-${dc.componentConfig.id}`, "dataURI").then(res => ({ name: dc.componentData.boardComponentTitle, imgURI: res?.imgURI })))
        );

        ExportPowerBiToPdf(data_table, data_kpis, chart_refs_dataUris, data_roles, data_contract, contextSite.clientName)
    }

    //Render de componente.
    return (<>
                <AuthVerify currentToken={currentAuth} />
                {
                    boardStructureGeneric && boardComponentInfoRecursiveFilled &&
                    <>
                        {
                            userPropsKpi && (userPropsKpi.hasAccess === true || userPropsKpi.onlyObserver === true) &&
                            <>
                                <CalendarFilterMonthOnly inputParam_BoardId={boardStructureGeneric[0].id} inputParam_ForceShowCalendar={true} inputParam_HideSettings={true} />
                                <Card>
                                    <Card.Header className='card-header-compact' style={{backgroundColor: '#00778B', color: 'white'}}>
                                        <Card.Title className='justify-content-between h5'>
                                            <Row>
                                                <Col className='text-start'>{!isNullUndefinedOrEmpty(contract) ? contract.businessUnitCode : ""}</Col>
                                                <Col xl={8} className='text-center'>{!isNullUndefinedOrEmpty(contract) ? `${t('data-lang-lbl-performance')} - ${contract.legalEntityBuyerCode}` : ""}</Col>
                                                <Col className='text-end'>{!isNullUndefinedOrEmpty(contract) ? contract.contractCode : ""}</Col>
                                            </Row>
                                        </Card.Title>
                                        <div className='text-end'><ActionButton iconProps={{iconName: "PDF"}} text='Exportar' onClick={ExportToPdf} /></div>
                                    </Card.Header>
                                    <Row>
                                        <Col className='mt-4 h5'><div className='text-center'>{`${t('data-lang-lbl-contract')} ${!isNullUndefinedOrEmpty(contract) ? contract.name : ""}`}</div></Col>
                                    </Row>
                                    <Card.Body>
                                    {
                                        boardStructureGeneric.map((boardStructure, indexBoardStructure) => {
                                            return <div key={indexBoardStructure}>
                                                {
                                                    (!isNullUndefinedOrEmpty(boardStructureGeneric.name) ? boardStructureGeneric.name : boardStructureGeneric[0].name) === "TABLERO COMPARE" &&
                                                    <CONSOLIDATE_GROUP_CONTRACT_FILTER_TO_COMPARE
                                                        inputParam_UseFake ={false}
                                                        inputParam_HideHeader={false}
                                                        inputParam_ComponentContent={null}
                                                        inputParam_BoardId={!isNullUndefined(boardStructureGeneric.boardId) ? boardStructureGeneric.boardId : boardStructureGeneric[0].id}
                                                    />
                                                }
                                                {
                                                    boardStructure.l_structure.length === 1 &&
                                                    <ResponsiveGridLayout
                                                        measureBeforeMount={layoutConfiguration.measureBeforeMount}
                                                        breakpoints={layoutConfiguration.breakpoints}
                                                        cols={layoutConfiguration.cols}
                                                        rowHeight={layoutConfiguration.rowHeight}
                                                        isDraggable={false}
                                                        isDroppable={false}
                                                        isResizable={false}
                                                        margin={[10, 10, 10, 10]}
                                                    >
                                                        {
                                                            boardStructure.l_structure[0].l_container.map((container, index) => (
                                                                <div key={index} data-grid={ __onGetDataGridHtmlContainer(container) }  className="gridItem" style={{ height: `${container.h * 50}px`, width: `${container.w * 48.5}px` }}>
                                                                    {generateContainer(boardStructure, container)}
                                                                </div>
                                                            ))
                                                        }
                                                    </ResponsiveGridLayout>
                                                }
                                                {
                                                    boardStructure.l_structure.length > 1 &&
                                                    boardStructure.l_structure.map((structure, index) => {
                                                        return <ResponsiveGridLayout
                                                            key={index}
                                                            breakpoints={{ lg: 1200, xs: 480 }}
                                                            cols={ { lg: 12, xs: 6 } }
                                                            rowHeight={ structure.htmlStructure.rowHeight }
                                                            margin={[10, 10, 10, 10]}
                                                        >
                                                            {
                                                                structure.l_container.map((container, index) => (
                                                                    <div key={index} className="gridItem" style={{ height: `${container.h * 50}px`, width: `${container.w * 48.5}px` }}>
                                                                        {generateContainer(container)}
                                                                    </div>
                                                                ))
                                                            }
                                                        </ResponsiveGridLayout>
                                                    })
                                                }
                                            </div>
                                        }) 
                                    }
                                    </Card.Body>
                                </Card>
                            </>
                        }
                        {
                            userPropsKpi && (userPropsKpi.hasAccess === false && userPropsKpi.onlyObserver === false) &&
                            <div className="pt-5 mt-4">
                                <MessageBox  
                                    inputParam_Message={ (userPropsKpi.hasAccess === false ? t('data-lang-msg-accessdenied') : "") }
                                    inputParam_Display={ messageConfig.showMessage }
                                    inputParam_MessageType={ messageConfig.messageType }
                                    inputParam_SetterMessage={ setMessageConfig }
                                />
                            </div>
                        } 
                    </>
                }
                {
                    (!boardStructureGeneric || !boardComponentInfoRecursiveFilled) &&
                    <div>
                        <Loading inputParam_ShowLoading={true}/>
                    </div>
                } 
            </>
    );
}

export default PowerBI;